import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderVolyn(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-volyn/create-distribution-order-volyn",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderVolyn(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-volyn/create-distribution-to-order-volyn",
      params,
      callBackFn
    );
  },
  async getVolynAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-volyn/get-volyn-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
